import type { ComponentPropsWithRef } from 'react';

import { clsx } from '~/styles/utils';

import type { IconName } from '../Icon/Icon';

import { Icon } from '../Icon/Icon';
import { useNavigationContext } from './Navigation.context';
import { itemStyle } from './Navigation.css';
import { NavigationTooltip } from './NavigationTooltip';

export type NavigationExternalLinkProps = ComponentPropsWithRef<'a'> & {
  children: string;
  icon: IconName;
};

export const NavigationExternalLink = ({ children, className, icon, ...delegated }: NavigationExternalLinkProps) => {
  const { showLabels } = useNavigationContext();

  return (
    <NavigationTooltip tooltip={children}>
      <a {...delegated} aria-label={children} className={clsx(itemStyle, className)} target={delegated.target ?? '_blank'}>
        <Icon name={icon} />

        {showLabels && <span>{children}</span>}
      </a>
    </NavigationTooltip>
  );
};
